import { render, staticRenderFns } from "./AddPersonConditionModal.vue?vue&type=template&id=45061945"
import script from "./AddPersonConditionModal.vue?vue&type=script&lang=js"
export * from "./AddPersonConditionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports